import { axiosApi } from "../packages/axiosRequests";

export const namespaceList = ["south-africa", "kenya", "kuwait"];

export async function uploadValueChunk(chunk, namespace) {
  const {
    data: { data },
  } = await axiosApi.post(`/api/import/value/${namespace}`, chunk);
  return data;
}

export async function createValue(values) {
  return axiosApi.post(`/api/value/create`, values);
}

export async function getValueById(id) {
  console.log(id);
  const { data } = await axiosApi.get(`/api/value/${id}`);
  return data;
}

export async function updateValueById(id, values) {
  return axiosApi.put(`/api/value/${id}`, values);
}

export async function getValues({ code, namespace, year }, { limit, page }) {
  const {
    data: {
      data,
      meta: { pagination },
    },
  } = await axiosApi.get(`/api/values`, {
    params: {
      page: page,
      limit: limit,

      year: year,
      code: code,
      namespace: namespace,
    },
  });
  return {
    values: data,
    pagination,
  };
}
